<div class="parent">
  <div class="heading mode-dialog-header-legacy" cdkDrag mat-dialog-title cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <capra-icon icon="icon-warning"></capra-icon>
    <h1>Chart exceeds data visualization limits</h1>
  </div>
  <div class="header-container">
    <div class="description">{{ description }}</div>
    <div class="description">Choose one of the following to continue.</div>
  </div>
  <div class="content-container">
    <div class="radio-icon" *ngIf="canAutoAggregate">
      <input
        id="autoAggregateInput"
        type="radio"
        name="multi-values-step-radio"
        [value]="'AutoAggregate'"
        [(ngModel)]="selectedAction"
        (change)="onActionChange($event)"
      />
      <label for="autoAggregateInput" class="radio-label inline-icon icon-radio-inactive"
        >Aggregate <span class="field-name">{{ fieldName }}</span> with COUNT</label
      >
    </div>
    <div class="radio-icon">
      <input
        id="filterInput"
        type="radio"
        name="multi-values-step-radio"
        [value]="'Filter'"
        [(ngModel)]="selectedAction"
        (change)="onActionChange($event)"
      />
      <label for="filterInput" class="radio-label inline-icon icon-radio-inactive">Choose a field to filter</label>
    </div>
    <mode-labeled-field-list-menu
      class="field-list"
      *ngIf="selectedAction === 'Filter'"
      [label]="'Field'"
      [selected]="filterField"
      [fieldsInEncoding]="encodingFields"
      [otherFields]="otherFields"
      (menuChange)="onChangeField($event)"
    >
    </mode-labeled-field-list-menu>
    <div class="radio-icon">
      <input
        id="manualUpdateInput"
        type="radio"
        name="multi-values-step-radio"
        [value]="'ManualUpdate'"
        [(ngModel)]="selectedAction"
        (change)="onActionChange($event)"
      />
      <label for="manualUpdateInput" class="radio-label inline-icon icon-radio-inactive"
        >Continue using manual chart updates</label
      >
    </div>
    <div class="radio-icon">
      <input
        id="displayErrorInput"
        type="radio"
        name="multi-values-step-radio"
        [value]="'DisplayError'"
        [(ngModel)]="selectedAction"
        (change)="onActionChange($event)"
      />
      <label for="displayErrorInput" class="radio-label inline-icon icon-radio-inactive"
        >Continue with current configuration and display message.</label
      >
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="actions-right">
      <capra-button *ngIf="canUndo" class="action" variant="secondary" color="neutral" text="Undo" (click)="undo()"></capra-button>
      <capra-button class="action" text="{{ actionButtonText }}" color="normal" (click)="apply()"></capra-button>
    </div>
  </div>
</div>
